import { useNavigate } from "react-router-dom";
import { Avatar, Box, IconButton, Stack } from "@/common/styles/style";
import {
  CustomTypography,
  HeaderBox,
  stringAvatar,
  styles,
  TopBox,
} from "./style";
import { useAuth } from "@/hooks/useAuth";
import { useEffect, useState } from "react";
import logo from "@/assets/logo.png";
import { usePathName } from "@/hooks/usePathName";
import MenuPopover from "@/molecules/menuPopover";
import { Routes } from "@/router/routes";
import { getRoleName } from "@/helpers/getUserInfo";

export default function Header() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const title = usePathName();
  const [userData, setUserData] = useState({
    name: "",
    tenantName: "",
    role: "",
  });

  useEffect(() => {
    if (isAuthenticated) {
      const checkServerConnection = async () => {
        try {
          const response = await fetch("/api/user-info");

          const data = await response.json();
          if (response.ok) {
            console.log(data.message);
            const { id, role, ...userInfo } = data.result;
            setUserData({ ...userInfo, role: getRoleName(role) });
          } else {
            console.error("サーバ接続エラー: ", response.statusText);
          }
        } catch (error) {
          console.error("サーバ接続エラー:", error);
        }
      };

      checkServerConnection();
    }
  }, [isAuthenticated]);

  const handlePages = (tab: string) => {
    navigate(tab);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      const response = await fetch("/api/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (response.ok) {
        console.log(data.message);
        navigate(Routes.LOGIN);
      }
    } catch (error) {
      console.error("API呼び出しエラー:", error);
    }
  };

  return (
    <Box>
      <TopBox>
        <IconButton
          onClick={() => handlePages(Routes.MACHINE_LIST)}
          sx={styles.logo}
        >
          <img src={logo} alt="Logo" width="150" height="auto" />
        </IconButton>
        {isAuthenticated && (
          <Stack direction="row" spacing={5} sx={styles.alignCenter}>
            <CustomTypography>{userData?.tenantName}</CustomTypography>
            <CustomTypography sx={styles.cursorDefault}>
              {userData?.role}
            </CustomTypography>
            <Stack direction="row" spacing={1} sx={styles.alignCenter}>
              <Avatar {...stringAvatar(userData?.name as string)} />
              <CustomTypography onClick={handleClick}>
                {userData?.name}
              </CustomTypography>
              <MenuPopover
                anchorEl={anchorEl}
                handleMenuClose={handleClose}
                data={[
                  {
                    name: "プロフィール",
                    func: () => handlePages(Routes.USER_PROFILE),
                  },
                  { name: "ログアウト", func: handleLogout },
                ]}
              />
            </Stack>
          </Stack>
        )}
      </TopBox>
      {isAuthenticated && (
        <HeaderBox>
          <CustomTypography sx={styles.cursorDefault}>{title}</CustomTypography>
          <CustomTypography onClick={() => handlePages(Routes.USER_MANAGEMENT)}>
            ユーザー管理
          </CustomTypography>
        </HeaderBox>
      )}
    </Box>
  );
}
